/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EmailCleanupResult,
  EmailConfiguration,
  EmailStorageStats,
  ErrorResponse,
  Resource,
  StringResource,
} from '../models';
import {
    EmailCleanupResultFromJSON,
    EmailCleanupResultToJSON,
    EmailConfigurationFromJSON,
    EmailConfigurationToJSON,
    EmailStorageStatsFromJSON,
    EmailStorageStatsToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ResourceFromJSON,
    ResourceToJSON,
    StringResourceFromJSON,
    StringResourceToJSON,
} from '../models';

export interface CleanupEmailStorageStatsRequest {
    id: string;
}

export interface DeleteEmailConfigurationRequest {
    id: string;
}

export interface GetEmailConfigurationRequest {
    id: string;
}

export interface GetEmailStorageStatsRequest {
    id: string;
}

export interface MicrosoftAuthCompletedRequest {
    stringResource: StringResource;
}

export interface UpdateEmailConfigurationRequest {
    id: string;
    emailConfiguration: EmailConfiguration;
}

/**
 * 
 */
export class EmailApi extends runtime.BaseAPI {

    /**
     * Deletes all sent emails from an email account (Roles: super_admin)
     */
    async cleanupEmailStorageStatsRaw(requestParameters: CleanupEmailStorageStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailCleanupResult>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling cleanupEmailStorageStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/email/storage/{id}/cleanup`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailCleanupResultFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    cleanupEmailStorageStatsRequestOptionsRaw(requestParameters: CleanupEmailStorageStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling cleanupEmailStorageStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/email/storage/{id}/cleanup`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Deletes all sent emails from an email account (Roles: super_admin)
     */
    async cleanupEmailStorageStats(requestParameters: CleanupEmailStorageStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailCleanupResult> {
        const response = await this.cleanupEmailStorageStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an email configuration (Roles: super_admin)
     */
    async deleteEmailConfigurationRaw(requestParameters: DeleteEmailConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteEmailConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/email/configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    deleteEmailConfigurationRequestOptionsRaw(requestParameters: DeleteEmailConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteEmailConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/email/configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Deletes an email configuration (Roles: super_admin)
     */
    async deleteEmailConfiguration(requestParameters: DeleteEmailConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEmailConfigurationRaw(requestParameters, initOverrides);
    }

    /**
     * Gets an email configuration by ID (Roles: super_admin)
     */
    async getEmailConfigurationRaw(requestParameters: GetEmailConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailConfiguration>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getEmailConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/email/configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailConfigurationFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getEmailConfigurationRequestOptionsRaw(requestParameters: GetEmailConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getEmailConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/email/configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets an email configuration by ID (Roles: super_admin)
     */
    async getEmailConfiguration(requestParameters: GetEmailConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailConfiguration> {
        const response = await this.getEmailConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all email configurations (Roles: super_admin)
     */
    async getEmailConfigurationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EmailConfiguration>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/email/configurations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EmailConfigurationFromJSON));
    }

    /**
        Request Config Getter
     */
    getEmailConfigurationsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/email/configurations`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all email configurations (Roles: super_admin)
     */
    async getEmailConfigurations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EmailConfiguration>> {
        const response = await this.getEmailConfigurationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets email storage statistics (Roles: super_admin)
     */
    async getEmailStorageStatsRaw(requestParameters: GetEmailStorageStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailStorageStats>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getEmailStorageStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/email/storage/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailStorageStatsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getEmailStorageStatsRequestOptionsRaw(requestParameters: GetEmailStorageStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getEmailStorageStats.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/email/storage/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets email storage statistics (Roles: super_admin)
     */
    async getEmailStorageStats(requestParameters: GetEmailStorageStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailStorageStats> {
        const response = await this.getEmailStorageStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the Microsoft authentication URL to start the OAuth process (Roles:  admin)
     */
    async getMicrosoftAuthUrlRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Resource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/email/auth-url`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResourceFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getMicrosoftAuthUrlRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/email/auth-url`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets the Microsoft authentication URL to start the OAuth process (Roles:  admin)
     */
    async getMicrosoftAuthUrl(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Resource> {
        const response = await this.getMicrosoftAuthUrlRaw(initOverrides);
        return await response.value();
    }

    /**
     * Completes the Microsoft OAuth process (Roles: physician)
     */
    async microsoftAuthCompletedRaw(requestParameters: MicrosoftAuthCompletedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailConfiguration>> {
        if (requestParameters.stringResource === null || requestParameters.stringResource === undefined) {
            throw new runtime.RequiredError('StringResource','Required parameter requestParameters.stringResource was null or undefined when calling microsoftAuthCompleted.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/email/auth-completed`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StringResourceToJSON(requestParameters.stringResource),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailConfigurationFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    microsoftAuthCompletedRequestOptionsRaw(requestParameters: MicrosoftAuthCompletedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.stringResource === null || requestParameters.stringResource === undefined) {
            throw new runtime.RequiredError('StringResource','Required parameter requestParameters.stringResource was null or undefined when calling microsoftAuthCompleted.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/email/auth-completed`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: StringResourceToJSON(requestParameters.stringResource),
        };
        return responseConfig
    }

    /**
     * Completes the Microsoft OAuth process (Roles: physician)
     */
    async microsoftAuthCompleted(requestParameters: MicrosoftAuthCompletedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailConfiguration> {
        const response = await this.microsoftAuthCompletedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an email configuration (Roles: super_admin)
     */
    async updateEmailConfigurationRaw(requestParameters: UpdateEmailConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailConfiguration>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateEmailConfiguration.');
        }

        if (requestParameters.emailConfiguration === null || requestParameters.emailConfiguration === undefined) {
            throw new runtime.RequiredError('EmailConfiguration','Required parameter requestParameters.emailConfiguration was null or undefined when calling updateEmailConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/email/configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EmailConfigurationToJSON(requestParameters.emailConfiguration),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailConfigurationFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updateEmailConfigurationRequestOptionsRaw(requestParameters: UpdateEmailConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateEmailConfiguration.');
        }

        if (requestParameters.emailConfiguration === null || requestParameters.emailConfiguration === undefined) {
            throw new runtime.RequiredError('EmailConfiguration','Required parameter requestParameters.emailConfiguration was null or undefined when calling updateEmailConfiguration.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/email/configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: EmailConfigurationToJSON(requestParameters.emailConfiguration),
        };
        return responseConfig
    }

    /**
     * Updates an email configuration (Roles: super_admin)
     */
    async updateEmailConfiguration(requestParameters: UpdateEmailConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailConfiguration> {
        const response = await this.updateEmailConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
